module.exports = __webpack_public_path__ + "img/14.1cd0d951.png";